<template>
  <h1>kcal: <em>der</em> Kalorien-Calculator</h1>
  <section id="sec-calculation">
    <p>
      <label>
        Gewünschter Brennwert (kcal):
        <input v-model.number="targetedKilocalories" type="number" min="0">
      </label>
    </p>
    <p>
      <input type="checkbox" id="checkbox" v-model="withManualWeightCorrection">
      <label for="checkbox">manu. Gewichtskorrektur</label>
    </p>
    <p v-if="withManualWeightCorrection">
      <label>
        Korrektur (g):
        <input v-if="!isAndroid" v-model.number="manualWeightCorrection" type="number">
        <input v-else v-model.number="manualWeightCorrection" inputmode="text">
      </label>
    </p>
    <p>Gesamtmasse: {{ overallAmount.toFixed(0) }}g</p>
    <p>Berechn. Portion: {{ calculatedWeight.toFixed(0) }}g</p>
  </section>
  <section id="sec-ingredients">
    <h2>Zutaten</h2>
    <form @submit.prevent="addIngredient">
      <p>
        <label>
          Name:
          <input type="text" v-model.trim="ingredientForm.name" id="new-ingredient-name" v-bind:placeholder="'Zutat ' + (ingredients.length+1)">
        </label>
      </p>
      <p>
        <label>
          Brennwert (kcal/100g):
          <input type="number" min="0" v-model.number="ingredientForm.caloriesPerHundredGrams">
        </label>
      </p>
      <p>
        <label>
          Menge (g):
          <input type="number" min="1" v-model.number="ingredientForm.amountInGrams">
        </label>
      </p>
      <button>Hinzuf.</button>
    </form>
    <ul v-if="ingredients.length > 0">
      <li v-for="(ingredient, index) in ingredients" :key="ingredient.name">
        {{ingredient.name}}, {{ingredient.caloriesPerHundredGrams}}kcal/100g, {{ingredient.amountInGrams}}g <button @click="removeIngredient(index)">Entfernen</button>
      </li>
    </ul>
    <p v-else><em>Keine Zutaten</em></p>
  </section>
  <serving-result :data-ingredients="JSON.stringify(servingIngredients)"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {Ingredient} from "@/models/ingredient";
import Mixture from "@/models/recipe";

interface Data {
  ingredients: Ingredient[],
  weightCorrection: number,
  targetedKilocalories: number,
  withManualWeightCorrection: boolean,
  manualWeightCorrection: number,
  ingredientForm: Ingredient,
}

export default defineComponent({
  name: "CalculatorApp",
  methods: {
    addIngredient() {
      if (this.ingredientForm.name === "") {
        this.ingredientForm.name = `Zutat ` + (this.ingredients.length+1)
      }
      this.ingredients.push(this.ingredientForm);
      localStorage.setItem("ingredients", JSON.stringify(this.ingredients));

      this.ingredientForm = new Ingredient()
      document.getElementById("new-ingredient-name")!.focus()
    },
    removeIngredient(index: number) {
      this.ingredients.splice(index, 1);
      localStorage.setItem("ingredients", JSON.stringify(this.ingredients));
    },
  },
  data(): Data {
    const ingredientsJson = localStorage.getItem("ingredients");
    const weightCorrection = localStorage.getItem("manualWeightCorrection");

    return {
      ingredients: ingredientsJson === null ? [] : JSON.parse(ingredientsJson).map((obj: any) => new Ingredient(obj)),
      weightCorrection: 0.0,
      targetedKilocalories: 0.0,
      withManualWeightCorrection: false,
      manualWeightCorrection: weightCorrection === null ? 0.0 : JSON.parse(weightCorrection),
      ingredientForm: new Ingredient(),
    }
  },
  computed: {
      servingIngredients() {
      const totalAmount = Mixture.weight(this.ingredients);

      const ratio = this.calculatedWeight / (totalAmount + this.weightCorrection);
      return this.ingredients.map(ingredient =>
        new Ingredient({
          name: ingredient.name,
          amountInGrams: ingredient.amountInGrams * ratio,
          caloriesPerHundredGrams: ingredient.caloriesPerHundredGrams}
        ))
    },
    overallAmount(): number {
      return Mixture.weight(this.ingredients);
    },
    isAndroid() {
      return window.navigator.userAgent.includes("Android");
    },
calculatedWeight(): number {
      let res = 0.0
      if (this.ingredients.length > 0) {
        let manualWeightCorrection = this.withManualWeightCorrection ? this.manualWeightCorrection : 0.0;
	localStorage.setItem("manualWeightCorrection", JSON.stringify(manualWeightCorrection));
        this.$emit("weight-correction", manualWeightCorrection);
        res = (this.targetedKilocalories / Mixture.calories(this.ingredients)) * (Mixture.weight(this.ingredients)+manualWeightCorrection)
      }
      return res;}
  }
})
</script>
